import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  // login page
  getContact(URL, header, success, error) {
    Vue.axios.get(URL + 'v2/checkin/contact', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  Login(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'v2/authen/login', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  OAuth(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'v2/authen/oauth', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  // checkin page
  getAreaList(URL, header, success, error) {
    Vue.axios.get(URL + 'v2/checkin/arealist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRecentCheckin(URL, header, success, error) {
    Vue.axios.get(URL + 'v2/checkin/recentcheckin', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addCheckin(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'v2/checkin/addcheckin', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/apis.js